var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBagBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 7.5V4.56201M6.00006 7.5V4.56201M6.00006 4.56201V3.75C6.00006 2.09315 7.3432 0.75 9.00006 0.75C10.6569 0.75 12.0001 2.09315 12.0001 3.75V4.56201M6.00006 4.56201C6.59009 4.5 7.34198 4.5 8.39098 4.5H9.60912C10.6581 4.5 11.41 4.5 12.0001 4.56201M6.00006 4.56201C5.54852 4.60947 5.19176 4.69324 4.86917 4.84112C4.21345 5.14172 3.65835 5.62506 3.2704 6.23319C2.83015 6.92331 2.70278 7.84041 2.44803 9.67459C2.1209 12.0299 1.95733 13.2076 2.31698 14.1222C2.63271 14.9252 3.21568 15.5948 3.96758 16.0179C4.82406 16.5 6.01304 16.5 8.39099 16.5H9.60913C11.9871 16.5 13.176 16.5 14.0325 16.0179C14.7844 15.5948 15.3674 14.9252 15.6831 14.1222C16.0428 13.2076 15.8792 12.0299 15.5521 9.67459C15.2973 7.84041 15.17 6.92331 14.7297 6.23319C14.3418 5.62506 13.7867 5.14172 13.1309 4.84112C12.8083 4.69324 12.4516 4.60947 12.0001 4.56201",
    stroke: "#00205E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagBlue);
export default __webpack_public_path__ + "static/media/bagBlue.ac421993bb2048e5d3b083ff1198fdb9.svg";
export { ForwardRef as ReactComponent };